angular.module('bmsApp.marketing').controller('CampaignIndexCtrl', function ($scope,
																			 $rootScope,
																			 $timeout,
																			 $log,
																			 CampaignSvc,
																			 LicenseOptionsSvc,
																			 ngTableParams,
																			 $state,
																			 $window,
																			 $cookies,
																			 $localStorage) {

	$scope.campaigns = {};
	$scope.loading = false;
	$scope.updating = false;
	$scope.campaignCount = 0;

	var defaultCampaignParams = function () {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				active: 'desc' // initial sorting
			},
			filter: {
				budget: {
					min: 0,
					max: 50000
				},
				search: '',
				license: 0
			}
		};
	};

	LicenseOptionsSvc.license().then(function(response) {
		$scope.licenses = response.data.options;
	});


	var initialCampaignParams = function () {
		if (angular.isDefined($localStorage.campaignIndexParams)) {
			return angular.extend({}, defaultCampaignParams(), $localStorage.campaignIndexParams);
		}
		else {
			return angular.extend({}, defaultCampaignParams());
		}
	};

	var params = initialCampaignParams();

	// copy the filters to a workable state
	$scope.campaignFilters = angular.copy(params.filter);

	$scope.valueSlider = {
		floor: 0,
		ceil: 50000,
		format: function (value) {
			return '£' + value;
		}
	};

	$scope.tableParams = new ngTableParams(params, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$localStorage.campaignIndexParams = params.$params;
			CampaignSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.campaign_filtered_count);
					$scope.campaignCount = response.data.campaign_filtered_count;
					$scope.campaigns = response.data.campaign_collection;

					var tableCount = {
						total: $scope.campaignCount,
						page: response.data.campaign_collection.length
					};

					$scope.campaign_total_count = response.data.campaign_total_count;
					$scope.valueSlider.ceil = response.data.campaign_max;
					// if it's greater than the max or equals the default max
					if ($scope.campaignFilters.budget.max > $scope.valueSlider.ceil || $scope.campaignFilters.budget.max == defaultCampaignParams().filter.budget.max) {
						$scope.campaignFilters.budget.max = $scope.valueSlider.ceil;
					}

					if (_.size($scope.tableParams.$params.filter.budget) == 0) { // No budget filter so set filters to default max value
						//$scope.valueSlider.ceil = response.data.campaign_max;
						//defaultFilters.budget.max = response.data.campaign_max;
						//$scope.filters = angular.copy(defaultFilters);
					}

					$scope.$emit('campaignIndexUpdated', tableCount);
					$defer.resolve(response.data.campaign_collection);

					// Check if we've exceeded our page size, if we have, go back
					if (response.data.campaign_filtered_count > 0 && !response.data.campaign_collection.length) {
						let newParams = angular.copy($scope.tableParams.$params);
						newParams.page--;
						angular.extend($scope.tableParams.$params, newParams);
					}
					$scope.updating = false;
				});
		}
	});

	// Store the table params whenever anything changes
	$scope.$watch('tableParams.$params', function (value) {
		if (angular.isObject(value)) {
			$cookies.campaignIndexParams = JSON.stringify(value);
		}
	}, true);

	// text search
	$scope.filterChanged = function () {
		$scope.tableParams.$params.filter.search = $scope.campaignFilters.search;
	};

	$scope.filterApply = function () {
		angular.extend($scope.tableParams.$params.filter, angular.copy($scope.campaignFilters));
	};

	$scope.filterToggled = function (open) {
		if (open) {
			$timeout(function () {
				$scope.$broadcast('rzSliderForceRender');
			}, 500);
		}
	};

	$scope.rowClicked = function (group) {
		$state.go("main.marketing.campaignIndex.campaignOverview", {campaignId: group.id});
	};

	$scope.export = function ($event, group) {
		$window.location.href = '/api/marketing/advertisingGroup/export/' + group.id;
		$event.stopPropagation();
	};

	$scope.filterReset = function () {
		angular.extend($scope.tableParams.$params, defaultCampaignParams());
		angular.extend($scope.campaignFilters, defaultCampaignParams().filter);
		$scope.campaignFilters.budget.max = $scope.valueSlider.ceil;
	};

});
